<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>
                Quality Control On Account Data
                {{ campaignName != null ? campaignName : "" }}
              </h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <div>
            <DataGrid :context="''" 
              ref="SDQCAccount"
              :columnDefs="accountColumnDefs"
              :rowData="accountRecords"
              :dataSource="accountDataSource"
              :rowSelection="'single'"
            >
            </DataGrid>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import moduleElomarkUserManagement from "@/store/elomark-user-management/moduleElomarkUserManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import vSelect from "vue-select";
import _ from "lodash";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import AccountAutocomplete from "@/components/autocomplete/AccountsAutocomplete.vue";
export default {
  beforeMount() {
    this.getAccountDataSource();
  },
  data() {
    return {
      showCampaignSelection: false,
      showDastatusrid: false,
      accountColumnDefs: [],
      selected_campaign: null,
      accountDataSource: {},
      accountRecords: [],
      campaignId: null,
      campaignName: null,
      selected_table_ids: [],
      selected_sales_developer_id: null,
      selected_status: []
    };
  },
  components: {
    "v-select": vSelect,
    DataGrid,
    AccountAutocomplete,
    CampaignAutocomplete
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];

    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }

    if (!moduleElomarkUserManagement.isRegistered) {
      this.$store.registerModule(
        "elomarkUsersManagement",
        moduleElomarkUserManagement
      );
      moduleElomarkUserManagement.isRegistered = true;
    }

    this.campaignName = atob(this.$route.params.campaignName);
  },
  mounted() {
  },
  watch: {},
  methods: {
    goBack: function() {
      this.$router.go(-1);
    },
    getAccountDataSource() {
      var self = this;
      self.accountDataSource = {
        getRows(params) {
          params.request.campaignId = self.$route.params.campaignId;
          params.request.campaignName = atob(self.$route.params.campaignName);
          self.$store
            .dispatch("accountsManagement/fetchAllQualityControlAccounts", params.request)
            .then(function(response) {
              let response_data = response.rows;

          response_data.forEach(function(ele) {
            if (ele.account_web) {
              if (ele.account_web.length == 0) {
                ele.website = "";
              } else if (ele.account_web.length > 1) {
                ele.website = "ΞΞ";
              } else {
                ele.website = ele.account_web[0].url;
              }
            }
          });

          response_data.forEach(function(ele) {
            if (ele.account_linkedin) {
              if (ele.account_linkedin.length == 0) {
                ele.linkedin = "";
              } else if (ele.account_linkedin.length > 1) {
                ele.linkedin = "ΞΞ";
              } else {
                ele.linkedin = ele.account_linkedin[0].url;
              }
            }
          });

          response_data.forEach(function(ele) {
            if (ele.account_phone) {
              if (ele.account_phone.length == 0) {
                ele.phone = "";
              } else if (ele.account_phone.length > 1) {
                ele.phone = "ΞΞ";
              } else {
                ele.phone = ele.account_phone[0].phone_no;
              }
            }
          });
              if (response_data.length != 0) {
                self.$refs.SDQCAccount.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.SDQCAccount.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    getSDAccountColumns() {
      let self = this;
      self.$store
        .dispatch(
          "campaignsManagement/getSDAccountColumns",
          self.$route.params.campaignId
        )
        .then(res => {
          let account_columns = JSON.parse(res.data);

          account_columns.forEach(function(ele) {
            // if (
            //   ele.column_name == "email" ||
            //   ele.column_name == "website" ||
            //   ele.column_name == "linkedin"
            // ) {
            //   ele.cellRenderer = function() {
            //     return '<span><i class="material-icons">burst_mode</i></span>';
            //   };
            // }

            ele.headerName = ele.column_name;
            ele.field = ele.column_name;
            ele.filter = "agTextColumnFilter";
            ele.width = 170;
            ele.filterParams = {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            };
          });

          var sorted = _.sortBy(account_columns, function(item) {
            return item.field === "surname" ? 0 : 1;
          });

          sorted = _.sortBy(sorted, function(item) {
            return item.field === "forename" ? 0 : 1;
          });

          sorted = _.sortBy(sorted, function(item) {
            return item.field === "title" ? 1 : 2;
          });

          let actions = {
            headerName: "Actions",
            field: "transactions",
            cellRenderer: "CellRendererActions",
            suppressHeaderMenuButton: true,
            checkboxSelection: false,

            pinned: true,
            width: 50
          };

          this.accountColumnDefs = sorted;
          this.accountColumnDefs.push(actions);

          let head_office_country = {
            column_name: "head_office_country",
            field: "head_office_country",
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "head_office_country"
          };

          this.accountColumnDefs.push(head_office_country);

          sorted = _.sortBy(sorted, function(item) {
            return item.field === "head_office_country" ? 1 : 2;
          });

          this.accountColumnDefs = sorted;

          let status = {
            column_name: "company_name",
            field: "company_name",
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "company_name"
          };

          this.accountColumnDefs.push(status);

          sorted = _.sortBy(sorted, function(item) {
            return item.field === "company_name" ? 0 : 1;
          });

          this.accountColumnDefs = sorted;

          let sales_developer = {
            column_name: "sales_developer",
            field: "sales_developer",
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "sales_developer"
          };

          this.accountColumnDefs.push(sales_developer);

           sorted = _.sortBy(sorted, function(item) {
            return item.field === "sales_developer" ? 0 : 1;
          });

          this.accountColumnDefs = sorted;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  beforeMount() {
    this.getSDAccountColumns();
    this.getAccountDataSource();
    this.$refs.SDQCAccount.gridApi.showNoRowsOverlay();
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}

.vertical-align {
  display: flex;
  justify-content: center; /* align horizontal */
  align-items: center; /* align vertical */
  /* width: 800px; */
}
</style>
